import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';

import './util/rxjs';

import { UserService } from './user/user.service';

@Injectable()
export class AuthGuard  {
  constructor(private router: Router, private userService: UserService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    // When this guard runs the profile of the current user might not be downloaded yet from the server.
    // This is why an Observable is needed.
    return this.userService.user$.map(user => {
      if (user.isAuthenticated) {
        return true;
      }

      // navigate to the login page, preserve the url to be able to redirect there after a successful login
      this.router.navigate(['login'], { queryParams: { url: encodeURIComponent(state.url) } });
      return false;
    });
  }
}

